import { useSyncExternalStore } from 'react';

function isFreshchatReady(): boolean {
  return typeof window !== 'undefined' && Boolean(window.fcWidget?.open ?? window.fcWidget?.show);
}

function subscribe(onStoreChange: () => void) {
  window.addEventListener('freshchat:loaded', onStoreChange);
  return () => {
    window.removeEventListener('freshchat:loaded', onStoreChange);
  };
}

function getSnapshot() {
  return isFreshchatReady();
}

function getServerSnapshot() {
  return false;
}

/**
 * Returns true while Freshchat scripts are still loading.
 * Loader hides once `window.fcWidget` is available.
 */
export function useFreshchatReady() {
  const isReady = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return !isReady;
}
